<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="80px"
  >
    <el-form-item
      label="规则名称"
      prop="ruleName"
    >
      <el-input
        v-model="form.ruleName"
        placeholder="文章标题"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="匹配词"
      prop="matchValue"
    >
      <tags-editor
        v-model="form.matchValue"
      ></tags-editor>
    </el-form-item>
    <el-row>
      <el-col :span="12">
        <el-form-item
          label="作用范围"
          prop="appid"
        >
          <el-select
            v-model="form.appid"
            placeholder="作用范围"
          >
            <el-option
              label="全部公众号"
              value=""
            ></el-option>
            <el-option
              label="当前公众号"
              :value="selectedAppid"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="精确匹配"
          prop="exactMatch"
        >
          <el-switch
            v-model="form.exactMatch"
            :active-value="true"
            :inactive-value="false"
          ></el-switch>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item
          label="回复类型"
          prop="replyType"
        >
          <el-select
            v-model="form.replyType"
            @change="onReplyTypeChange"
          >
            <el-option
              v-for="(name,key) in $config.KefuMsgType"
              :key="key"
              :value="key"
              :label="name"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="是否启用"
          prop="status"
        >
          <el-switch
            v-model="form.status"
            :active-value="true"
            :inactive-value="false"
          ></el-switch>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item
          label="生效时间"
          prop="effectTimeStart"
        >
          <el-time-picker
            v-model="form.effectTimeStart"
            value-format="HH:mm:ss"
          ></el-time-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="失效时间"
          prop="effectTimeEnd"
        >
          <el-time-picker
            v-model="form.effectTimeEnd"
            value-format="HH:mm:ss"
          ></el-time-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item
      label="回复内容"
      prop="replyContent"
    >
      <el-input
        v-model="form.replyContent"
        type="textarea"
        :rows="5"
        placeholder="文本、图文ID、media_id、json配置"
      ></el-input>
      <el-button
        type="text"
        v-show="'text'==form.replyType"
        @click="addLink"
      >插入链接</el-button>
      <el-button
        type="text"
        v-show="assetsType"
        @click="materialInsetHandle"
      >
        从素材库中选择
        <span
          v-if="'miniprogrampage'==form.replyType || 'music'==form.replyType"
        >缩略图</span>
      </el-button>
    </el-form-item>
    <el-form-item
      label="备注说明"
      prop="desc"
    >
      <el-input
        v-model="form.desc"
        placeholder="备注说明"
      ></el-input>
    </el-form-item>
    <metarial-img-dialog
      :select-type="assetsType"
      :dialog-show="metarialImgDialogShow"
      @selected="onAssetsSelect"
      @close="closeHandle"
    ></metarial-img-dialog>
    <metaria-news-dialog
      :select-type="assetsType"
      :dialog-show="metarialImgNewDialogShow"
      @selected="onAssetsSelect"
      @close="closeNewHandle"
    ></metaria-news-dialog>
  </el-form>
</template>

<script>
import metariaNewsDialog from "../material/materialNew/metariaNewsDialog";
import metarialImgDialog from "../material/materialNew/metarialImgDialog";
import tagsEditor from "@/components/common/tagsEditor";
import { mapGetters } from 'vuex'
let origin = {
  ruleId: 0,
  ruleName: '',
  matchValue: '',
  appid: '',
  exactMatch: false,
  replyType: '',
  status: true,
  effectTimeStart: "00:00:00",
  effectTimeEnd: "23:59:59",
  replyContent: "",
}
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "articleForm",
  components: {
    tagsEditor,
    metarialImgDialog,
    metariaNewsDialog,
  },
  props: {
    formData:{
      type: Object,
      default(){
        return {
          id: ''
        };
      }
    }
  },
  data() {
    return {
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        ruleName: [
          { required:true, message: '规则名称不能为空', trigger: 'blur' },
        ],
        matchValue: [
          { required:true, message: '匹配的关键词、事件等不能为空', trigger: 'blur' },
        ],
        replyType: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        status: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        effectTimeStart: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        effectTimeEnd: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        replyContent: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
      },
      assetsSelectorVisible: false, // 需要图文选择弹框 todo

      metarialImgDialogShow: false,
      metarialImgNewDialogShow: false,
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.ruleId){
          this.assigen(newValue);
        }
      },
      deep: true,
    }
  },
  computed: {
    ...mapGetters(['selectedAppid']),
    assetsType(){
      const config={//消息类型与选择素材类型对应关系
        'image':'image',
        'voice':'voice',
        'video':'video',
        'mpnews':'news',
        'miniprogrampage':'image',//小程序需选择卡片图
        'music':'image'
      }
      return config[this.form.replyType] || ''
    }
  },
  mixins: [formLabalPosition],
  methods: {
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },
    assigen(data){
      this.form = {
        ...data,
      };
    },
    addLink() {
      this.form.replyContent += '<a href="链接地址">链接文字</a>'
    },
    materialInsetHandle(){
      this.toggleDialog(true);
    },
    toggleDialog(flag){
      switch (this.assetsType){
        case 'image':
        case 'voice':
        case 'video':
          this.metarialImgDialogShow = flag;
          break;
        case 'news':
          this.metarialImgNewDialogShow = flag;
          break;
      }
    },
    onReplyTypeChange(value) {
      if ("miniprogrampage" == value) {
        let demo = { title: "标题", appid: "小程序APPID", pagepath: "页面地址", thumb_media_id: "缩略图media_id" };
        this.form.replyContent = JSON.stringify(demo, null, 4)
      } else if ("music" == value) {
        let demo = { musicurl: "音乐链接", hqmusicurl: "高品质链接", title: "标题", description: "描述", thumb_media_id: "缩略图media_id" }
        this.form.replyContent = JSON.stringify(demo, null, 4)
      } else if ("msgmenu" == value) {
        let demo = { head_content: "开头文字", list: [{ id: "菜单1ID", content: "菜单2内容" }, { id: "菜单2ID", content: "菜单2内容" }, { id: "菜单nID", content: "菜单n内容" }], tail_content: "结尾文字" }
        this.form.replyContent = JSON.stringify(demo, null, 4)
      } else if ("news" == value) {
        let demo={title:"文章标题",description:"文章简介",url:"链接URL",picUrl:"缩略图URL"}
        this.form.replyContent = JSON.stringify(demo, null, 4)
      } else {
        this.form.replyContent = '媒体素材media_id'
      }
    },
    onAssetsSelect(assetsInfo){
      if(this.form.replyType=='miniprogrampage' || this.form.replyType=='music'){
        let data = JSON.parse(this.form.replyContent)
        if(data && data.thumb_media_id) data.thumb_media_id = assetsInfo.mediaId
        this.form.replyContent = JSON.stringify(data, null, 4)
      }else{
        this.form.replyContent = assetsInfo.mediaId
      }
      this.toggleDialog(false);
    },
    closeHandle(){
      this.metarialImgDialogShow = false;
    },
    closeNewHandle(){
      this.metarialImgNewDialogShow = false;
    },
    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }else {
          console.log('no-pass');
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
  },
}
</script>

<style scoped>

</style>
